import { requestJson } from './requestJson';

export async function postReviewerFinish(
  reviewerId: string,
  durationMs: number
): Promise<{ finished: boolean }> {
  return await requestJson(`/api/reviewers/${encodeURIComponent(reviewerId)}/finish`, {
    method: 'POST',
    body: JSON.stringify({ duration_ms: durationMs })
  });
}
